import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "invoice-partial-return" }
const _hoisted_2 = { class: "invoice-partial-return__header" }
const _hoisted_3 = { class: "invoice-partial-return__container mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "container__state"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "Загрузка данных...", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных произошла ошибка", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных произошла ошибка", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "Данная накладная уже закрыта", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "Для данного функционала не включена подходящая настройка", -1)
const _hoisted_10 = {
  key: 1,
  class: "container__form"
}
const _hoisted_11 = { class: "form__block" }
const _hoisted_12 = { class: "flex items-center gap-3" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "text-sm text-gray-700" }
const _hoisted_16 = { class: "text-sm text-gray-700" }
const _hoisted_17 = { class: "flex items-center justify-end mt-2 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_select = _resolveComponent("the-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: _ctx.title }, null, 8, ["title"]),
      _createVNode(_component_router_link, {
        to: `/invoice/${_ctx.invoiceId}`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, {
            type: "button",
            class: "second small text"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Назад к накладной")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (
                    _ctx.invoice_state.is_loading || _ctx.settings_state.is_loading ||
                    _ctx.invoice_state.is_failed || _ctx.settings_state.is_failed ||
                    _ctx.isAlreadyClosed ||
                    !_ctx.settings_state.is_partial_return_enabled
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.invoice_state.is_loading || _ctx.settings_state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Loader, { class: "primary" }),
                  _hoisted_5
                ], 64))
              : (_ctx.invoice_state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_6,
                    _createVNode(_component_the_button, {
                      type: "button",
                      class: "small primary",
                      onClick: _ctx.loadInvoice
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Обновить")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.settings_state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_7,
                      _createVNode(_component_the_button, {
                        type: "button",
                        class: "small primary",
                        onClick: _ctx.loadCompanySettings
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Обновить")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.isAlreadyClosed)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _hoisted_8,
                        _createVNode(_component_router_link, {
                          to: `/invoice/${_ctx.invoiceId}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_the_button, {
                              type: "button",
                              class: "second small text"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Назад к накладной")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 64))
                    : (!_ctx.settings_state.is_partial_return_enabled)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _hoisted_9,
                          _createVNode(_component_the_button, {
                            type: "button",
                            class: "small primary",
                            onClick: _ctx.loadCompanySettings
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Обновить")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : _createCommentVNode("", true)
          ]))
        : (_ctx.invoice_state.invoice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_the_input, {
                  placeholder: "Выберите новую дату",
                  value: _ctx.state.deliveredAt,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.deliveredAt) = $event)),
                  type: "datetime-local",
                  disabled: _ctx.isLoading,
                  "is-invalid": _ctx.state_form$.deliveredAt.$error,
                  "validation-errors": _ctx.state_form$.deliveredAt.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
                _createVNode(_component_file_reader, {
                  class: "mt-2",
                  accept: "image/*",
                  placeholder: "Файлы",
                  multiple: "",
                  value: _ctx.state.attachments,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.attachments) = $event)),
                  disabled: _ctx.isLoading,
                  "is-invalid": _ctx.state_form$.attachments.$error,
                  "validation-errors": _ctx.state_form$.attachments.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  placeholder: "ФИО получателя",
                  value: _ctx.state.receiverName,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.receiverName) = $event)),
                  disabled: _ctx.isLoading,
                  "is-invalid": _ctx.state_form$.receiverName.$error,
                  "validation-errors": _ctx.state_form$.receiverName.$errors
                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice_state.invoice.invoice_places, (place, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form__block mt-2",
                  key: place.id
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.invoicePlaces[i].statusId === 10,
                      disabled: _ctx.isLoading,
                      onClick: ($event: any) => (_ctx.toggleStatus(i))
                    }, null, 8, ["value", "disabled", "onClick"]),
                    _createElementVNode("p", _hoisted_13, [
                      (place.productName)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(place.productName), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Место №" + _toDisplayString(i + 1), 1)
                          ], 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(place.barcode || '-'), 1),
                    _createElementVNode("p", _hoisted_16, "S/N: " + _toDisplayString(place.serialNumber || '-'), 1)
                  ]),
                  (_ctx.state.invoicePlaces[i].statusId === 51)
                    ? (_openBlock(), _createBlock(_component_the_select, {
                        key: 0,
                        disabled: _ctx.isLoading,
                        value: _ctx.state.invoicePlaces[i].cancelReasonId,
                        loading: _ctx.cancel_reasons_state.is_loading,
                        failed: _ctx.cancel_reasons_state.is_failed,
                        options: _ctx.cancel_reasons_state.options,
                        searchable: false,
                        "is-invalid": _ctx.state.invoicePlaces[i].statusId === 51 && !_ctx.state.invoicePlaces[i].cancelReasonId,
                        onRefresh: _ctx.loadCancelReasons,
                        onChange: (cancelReasonId) => _ctx.onChangeCancelReason(i, cancelReasonId)
                      }, null, 8, ["disabled", "value", "loading", "failed", "options", "is-invalid", "onRefresh", "onChange"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_the_button, {
                  type: "button",
                  loading: _ctx.isLoading,
                  class: "primary small",
                  onClick: _ctx.onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Подтвердить")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}